// 非同期に読み込むファイル

export default (string) => `${string}!`



// WEBPACK FOOTER //
// ./async/message.js